/**
 * WPML language cookie helper.
 *
 * Shared writer for grow_lang cookie options used by switcher and browser prompt.
 */
(function () {
	/**
	 * Write language cookie with normalized options.
	 *
	 * @param {Object} cfg  Config with cookie options.
	 * @param {string} lang Language code to persist.
	 * @return {void}
	 */
	function writeLanguageCookie(cfg, lang) {
		if (!cfg || !cfg.cookieName || !lang) {
			return;
		}

		const expiry = parseInt(cfg.cookieExpiry, 10);
		const expiryTs = isNaN(expiry) ? 0 : expiry;
		const maxAge = Math.max(0, expiryTs - Math.floor(Date.now() / 1000));
		const expDate = new Date(expiryTs * 1000).toUTCString();

		let cookie =
			cfg.cookieName +
			'=' +
			encodeURIComponent(lang) +
			'; path=' +
			(cfg.cookiePath || '/') +
			'; expires=' +
			expDate +
			'; Max-Age=' +
			maxAge +
			'; SameSite=' +
			(cfg.sameSite || 'Lax');

		if (cfg.cookieDomain) {
			cookie += '; domain=' + cfg.cookieDomain;
		}
		if (cfg.secure) {
			cookie += '; Secure';
		}

		document.cookie = cookie;
	}

	window.growtherapyWpmlWriteLanguageCookie = writeLanguageCookie;
})();
